<div id="end-page-view__container" class="end-page-view__container">
  <empathy-viewer-template-card [noHeader]="true">
    <div slot="details" class="end-page-view__container__content">
      <div class="fs__lg" [innerHTML]="endPage().html"></div>
    </div>
  </empathy-viewer-template-card>
</div>

<div class="end-page-view__footer">
  <empathy-viewer-progress-bar [progress]="100"></empathy-viewer-progress-bar>
  <mat-toolbar class="end-page-view__footer__toolbar">
    <empathy-viewer-button
      [text]="(endPage().buttonText | toPlainText) || ('system.complete' | translate)"
      [loadingText]="'system.sending' | translate"
      [testId]="'survey-end-page-complete'"
      (clicked)="completed.emit()"
    ></empathy-viewer-button>
  </mat-toolbar>
</div>
